var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"M-Flipper",class:[_vm.flipType, { go: _vm.isFlipping }],style:({
    width: `${_vm.styleConfig.width}px`,
    height: `${_vm.styleConfig.height}px`,
    lineHeight: `${_vm.styleConfig.height}px`,
    fontSize: `${_vm.styleConfig.fontSize}px`,
    color: _vm.styleConfig.color
  })},[_c('div',{staticClass:"digital front",class:_vm._textClass(_vm.frontTextFromData),style:({ '--pseudoElementBg': _vm.styleConfig.background })}),_c('div',{staticClass:"digital back",class:_vm._textClass(_vm.backTextFromData),style:({ '--pseudoElementBg': _vm.styleConfig.background })})])
}
var staticRenderFns = []

export { render, staticRenderFns }